import reactErrorCodes from './react-error-codes.json';

const MINIFIED_REACT_ERROR_CODE_PATTERN = /Minified React error #(\d+)/;

const MINIFIED_REACT_ERROR_BOILERPLATE_PATTERN =
    /(Error: )?Minified React error #\d+; visit https:\/\/(?:reactjs\.org|react\.dev)[^\n]*/;

const reactErrorCodeLookup = reactErrorCodes as Record<string, string>;

export function getMinifiedReactErrorCode(text: string): string | null {
    const match = MINIFIED_REACT_ERROR_CODE_PATTERN.exec(text);

    return match?.[1] ?? null;
}

export function decodeMinifiedReactError(text: string): string {
    const errorCode = getMinifiedReactErrorCode(text);

    if (!errorCode) {
        return text;
    }

    const fullMessage = reactErrorCodeLookup[errorCode];

    if (!fullMessage) {
        return text.replace(
            MINIFIED_REACT_ERROR_BOILERPLATE_PATTERN,
            (_, errorPrefix?: string) =>
                `${errorPrefix ?? ''}Minified React error #${errorCode} (see https://react.dev/errors/${errorCode})`,
        );
    }

    return text.replace(MINIFIED_REACT_ERROR_BOILERPLATE_PATTERN, (_, errorPrefix?: string) => {
        return `${errorPrefix ?? ''}${fullMessage}`;
    });
}
